import axiosInstance from 'utils/axiosInstance';
import {
  ChangeStatus,
  ExpenseCat,
  ExpenseData,
  ExpenseDetail,
  ExpensesStats,
  ExportFilters,
  NoteDetailResponse,
  NotesDataTableResponse,
  NotesFilterDataTable,
  SelectItem,
} from '../types/type';

export const GetNotes = async (
  filters: NotesFilterDataTable,
): Promise<ApiResponse<NotesDataTableResponse>> => {
  const { data } = await axiosInstance.post<
    ApiResponse<NotesDataTableResponse>
  >('api/Notes/List', filters);
  return data;
};

export const GetDetailsExpense = async (
  id: number,
): Promise<ApiResponse<NoteDetailResponse>> => {
  const { data } = await axiosInstance.get<ApiResponse<NoteDetailResponse>>(
    `api/Notes/GetById/${id}`,
  );
  return data;
};

export const GetExpensesCat = async (id: number): Promise<ExpenseCat[]> => {
  const { data } = await axiosInstance.get<ApiResponse<ExpenseCat[]>>(
    `api/ExpensesCat/List/${id}`,
  );
  return data.data;
};

export const GetPayBy = async (): Promise<ApiResponse<SelectItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    'api/Expenses/createformdata',
  );
  return data;
};

export const GetCurrency = async (): Promise<ApiResponse<SelectItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    'api/settings/CurrencyList',
  );
  return data;
};

export const GetDetailsCategory = async (
  id: number,
): Promise<ApiResponse<ExpenseDetail>> => {
  const { data } = await axiosInstance.get<ApiResponse<ExpenseDetail>>(
    `api/Expenses/GetById/${id}`,
  );
  return data;
};

export const GetExpensesCatById = async (
  id: number,
): Promise<ApiResponse<ExpenseCat>> => {
  const { data } = await axiosInstance.get<ApiResponse<ExpenseCat>>(
    `api/ExpensesCat/GetById/${id}`,
  );
  return data;
};

export const deleteNote = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `api/Notes/Delete/${id}`,
  );
  return data;
};

export const changestatusNote = async (
  info: ChangeStatus,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/Notes/changestatus',
    info,
  );
  return data;
};

export const supportChangeStatusNote = async (
  info: ChangeStatus,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/Notes/SupportChangeStatus',
    info,
  );
  return data;
};

export const deleteExpenses = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `api/Expenses/Delete/${id}`,
  );
  return data;
};

export const UpdateOrCreateExpenseCat = async (credentials: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/Expenses/Create',
    credentials,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return data;
};

export const UpdateOrCreateExpense = async (credentials: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/Notes/Create',
    credentials,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return data;
};

export const GetExpensesStats = async (): Promise<
  ApiResponse<ExpensesStats>
> => {
  const { data } = await axiosInstance.get<ApiResponse<ExpensesStats>>(
    'api/Notes/NoteStatistics',
  );
  return data;
};

export const ExportNotesToZip = async (
  filters: ExportFilters,
): Promise<ApiResponse<string>> => {
  const { data } = await axiosInstance.post<ApiResponse<string>>(
    'api/Notes/ExportNotesToZip',
    filters,
  );
  return data;
};

export const DeleteFile = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `api/Expenses/DeleteFile/${id}`,
  );
  return data;
};

export const GetExpenseData = async (noteId: number) => {
  const { data } = await axiosInstance.get<ExpenseData>(
    `api/Notes/GetExpenseData/${noteId}`,
  );
  return data;
};

export const exportExpensesResponse = async (
  html: string,
  title: string,
  noteId: number,
): Promise<ArrayBuffer> => {
  const { data } = await axiosInstance.post<ArrayBuffer>(
    'api/Notes/exportNoteToPdf',
    { html, title, noteId },
    { responseType: 'arraybuffer' },
  );
  return data;
};
